import { gql } from '@apollo/client';
import { genericFields } from './index';

export const bookmarksFragment = gql`
  fragment bookmarksItemFields on Item {
    ${genericFields}
    business {
      ... on Agency {
        id
      }
      ... on Residence {
        id
      }
    }
    photos(limit: 4) {
      thumbnail
      f460x345
      large
    }
  }
`;
